module.exports = __webpack_public_path__ + "img/bookmark-star-fill.65d4fd6f.svg";